import React, { Fragment } from 'react';

import glassData from '../../../../../data/glassData.js';
import TEXT from '../../../../../data/text.json';

import FormController from '../../form-components/form-controller';
import OverlayWrapper from '../../form-components/overlay-wrapper';
import FormWrapper from '../../form-components/form-wrapper';
import ImageSelection from '../../form-components/image-selection';
import EmailInput from '../../form-components/email-input';
import ErrorMessage from '../../form-components/error-message';

export default class ImageForm extends FormController {
  constructor(props) {
    super(
      props,
      ['images', 'emailValue', 'mainImageValue'],
      ['images', 'emailValue'],
      2
    );

    this.hasExistingImage = !!glassData.find(({ id }) => id === props.itemId)
      .mainImage;
  }

  handleSetImages = (images, removedMain, removedIndex) => {
    if (removedMain) {
      if (!this.hasExistingImage) {
        // If the user just removed the image with was selected as "Main" then set
        // the first image as Main if the item currently has no images
        this.setMainImageValue({ target: { value: 0 } });
      } else {
        // If the user just removed the image with was selected as "Main" then set
        // the value as null if the item currently has some images
        this.setMainImageValue({ target: { value: null } });
      }
    } else {
      // If the user just added the first image and the item currently has no
      // images then make the first image the "Main"
      if (
        this.state.images.length === 0 &&
        images.length === 1 &&
        !this.hasExistingImage
      ) {
        this.setMainImageValue({ target: { value: 0 } });
      } else {
        // If the index of the removed image was less than the index of the selected
        // main then we need to decrement the main index value
        if (removedIndex < this.state.mainImageValue) {
          this.setMainImageValue({
            target: { value: this.state.mainImageValue - 1 }
          });
        }
      }
    }
    // Pass up to the actual setImages function
    this.setImages(images);
  };

  render() {
    const { closeForm, secondaryButtonIsBack, clearForm } = this.props;
    return (
      <OverlayWrapper
        title={TEXT.CONTRIBUTION_FORMS.ADD_IMAGES.title}
        subTitle={TEXT.CONTRIBUTION_FORMS.ADD_IMAGES.subTitle}
        footerProps={this.getFooterProps()}
        stages={[
          {
            name: 'New Images',
            active: this.state.stage === 1,
            onClick: () => this.setState({ stage: 1 })
          },
          {
            name: 'Review',
            active: this.state.stage === 2,
            onClick: () => this.setState({ stage: 2 })
          }
        ]}
      >
        <FormWrapper>
          {this.state.stage === 1 && (
            <ImageSelection
              images={this.state.images}
              onChange={this.handleSetImages}
              requiresMain={!this.hasExistingImage}
              setMainImageValue={this.setMainImageValue}
              mainImageValue={this.state.mainImageValue}
            />
          )}

          {this.state.stage === 2 && (
            <Fragment>
              <EmailInput
                emailValue={this.state.emailValue}
                setEmailValue={this.setEmailValue}
              />

              {!this.state.formValid && (
                <ErrorMessage
                  title="Form not complete for submission"
                  message={this.validationMessage(this.state)}
                />
              )}
            </Fragment>
          )}
        </FormWrapper>
      </OverlayWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/contribution-form/forms/image-form/index.js